export default __webpack_public_path__ + "static/media/Chinmay Kumar Rout.7c2bbd32.jpeg";